import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { accountMapRulesOptions } from './getAccountMapRulesOptions'

/**
 * Hook that fetches account map rules for the current context company
 * Automatically gets companyId from Redux context
 */
export const useCtxAccountMapRules = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const options = accountMapRulesOptions(companyId)
  return useQuery(options)
}
